export default __webpack_public_path__ + "static/tv-show-1-629da1b17b905e91e8ae360466ef07bf.jpg";